import { PrintJobType, printTypeByPrintJobType } from '@/features/print/constants'
import { Printer } from '@/features/print/types'

export const getPrintersForPrintJobType = (
    printers: Printer[],
    printJobType: PrintJobType
): Printer[] => {
    const configuredPrintType = printTypeByPrintJobType[printJobType]

    return printers.filter((printer) => printer.printTypes.includes(configuredPrintType))
}
